import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React, { ComponentType } from 'react';
import ReactDOM from 'react-dom';
import getAppContainerId from '../dom/getAppContainerId';

const render = <T extends object>(App: ComponentType<T>, props?: T) => {
  const appNode = document.getElementById(getAppContainerId());

  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(
    <App {...props} />,
    appNode,
  );
};

export default render;
